var _defs, _g, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 700 130",
    width: 700,
    height: 130,
    role: "img",
    "aria-label": "singlestats",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "singlestats (dark)") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .sc-red   { fill:#DA2027; }\n      .sc-white { fill:#FFFFFF; }\n      .sc-text  {\n        font-family: 'Nunito', 'Quicksand', 'Mulish', 'Avenir Next', 'Helvetica Neue', Arial, sans-serif;\n        font-weight: 800;\n        font-size: 90px;\n        letter-spacing: -2px;\n        fill: #FFFFFF;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5,5)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "sc-red",
    x: 0,
    y: 0,
    width: 120,
    height: 120,
    rx: 22,
    ry: 22
  }), /*#__PURE__*/React.createElement("g", {
    className: "sc-white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 68,
    width: 14,
    height: 20,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 54,
    width: 14,
    height: 34,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 40,
    width: 14,
    height: 48,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 24,
    width: 14,
    height: 64,
    rx: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "29,62 49,48 69,34 89,18",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 62,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 48,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 34,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89,
    cy: 18,
    r: 4.5
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 92,
    className: "sc-text"
  }, /*#__PURE__*/React.createElement("tspan", null, "single"), /*#__PURE__*/React.createElement("tspan", {
    dx: 6
  }, "stats"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7c86d855ecb0ceb24cf92a86c4dcda42.svg";
export { ForwardRef as ReactComponent };